import React from "react";

const ExternalRedirect = () => {
  React.useEffect(() => {
    window.location.href = "https://www.instagram.com/copadeski?igsh=MWk1cmJ6eDlyYW13Ng==";
  }, []);

  return null;
};

export default ExternalRedirect;